import { render, staticRenderFns } from "./OpcionesDropdownTableComponent.vue?vue&type=template&id=77168690&scoped=true"
import script from "./OpcionesDropdownTableComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./OpcionesDropdownTableComponent.vue?vue&type=script&setup=true&lang=js"
import style0 from "./OpcionesDropdownTableComponent.vue?vue&type=style&index=0&id=77168690&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77168690",
  null
  
)

export default component.exports